import localReducer from './reducer'
import localSagas from './sagas'

const timezonesModule = {
  id: 'timezones',
  reducerMap: { timezones: localReducer },
  sagas: localSagas,
}

export default timezonesModule
